module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/28.a7bf0c87.jpg";